module.exports = __webpack_public_path__ + "img/soc.5fb3149a.svg";